import { Component, OnInit } from '@angular/core';
import {
  WebElement,
  WebTarger,
} from '../../_model';
import { WebTargetService } from '../../_service';

@Component({
  selector: 'element-create',
  template: require('./element-create.component.html'),
  styles: [require('./element-create.component.css')],
})

export class ElementCreateComponent implements OnInit {

  public webTarget: WebTarger = new WebTarger();

  public constructor(private webTargetService: WebTargetService){

  }

  public ngOnInit() {
    this.webTarget.webElements.push(new WebElement());
  }

  public addElement(){
    this.webTarget.webElements.push(new WebElement());
  }

  public minusElement(index){
    this.webTarget.webElements.splice(index, 1);
  }

  public create(){
    this.webTargetService.create(this.webTarget).subscribe();
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/web-targets/element-create/element-create.component.ts